/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SlackIdentityMapping = {
  /**
   * Whether the person and organization membership are active.
   */
  active: boolean;
  /**
   * Person's current display name.
   */
  displayName: string;
  /**
   * Person's current email.
   */
  email: string;
  /**
   * Immutable confirmation ID.
   */
  id: string;
  /**
   * Person's avatar URL.
   */
  photoUrl?: string | undefined;
  /**
   * Existing organization person ID.
   */
  userId: string;
};

/** @internal */
export const SlackIdentityMapping$inboundSchema: z.ZodMiniType<
  SlackIdentityMapping,
  unknown
> = z.pipe(
  z.object({
    active: z.boolean(),
    display_name: z.string(),
    email: z.string(),
    id: z.string(),
    photo_url: z.optional(z.string()),
    user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "photo_url": "photoUrl",
      "user_id": "userId",
    });
  }),
);

export function slackIdentityMappingFromJSON(
  jsonString: string,
): SafeParseResult<SlackIdentityMapping, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SlackIdentityMapping$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SlackIdentityMapping' from JSON`,
  );
}
